import { render, staticRenderFns } from "./PortalLockedCard.vue?vue&type=template&id=0e941cab&scoped=true&"
import script from "./PortalLockedCard.vue?vue&type=script&lang=js&"
export * from "./PortalLockedCard.vue?vue&type=script&lang=js&"
import style0 from "./PortalLockedCard.vue?vue&type=style&index=0&id=0e941cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e941cab",
  null
  
)

export default component.exports